var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ReportModalButton',{class:_vm.buttonClass,attrs:{"profileId":_vm.profileId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }